/* eslint-disable */
import React, { useEffect, useContext, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";

//import translation function for language translation
import { useTranslation } from "react-i18next";

// Import Editor here (both required).
// import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

/*import url and gateway methods */
import {
  postData,
  putData,
  uploadMultipleFile,
  getData,
  uploadSingleFile,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

import downloadFileHandler from "helper/DownloadFile";
import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
import { assetImages } from "constants";
import { joditEditorConfig, reactSelectStyle } from "Config/Config";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";

//image resize for editor
import { resizeOrCompressImage } from "helper/Common/CommonHelper";
import {
  getCurrentTime,
  getStartTimeFromCurrentTime,
} from "helper/TimeCalculation";

const CrmLogTab = ({
  selectedTaskId,
  contactId,
  leadId,
  projectId,
  isReset,
  setIsReset,
  getTaskList,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const params = useParams();

  const { t } = useTranslation(); // translation

  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [taskProjectId, settaskProjectId] = useState(null);
  const [taskLeadId, settaskLeadId] = useState(null);
  const [taskContactId, settaskContactId] = useState(null);

  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatusData, settaskStatusData] = useState("");
  const [taskPercent, settaskPercent] = useState("");
  const [logHours, setlogHours] = useState("");
  const [logStartDate, setlogStartDate] = useState(todayValue);
  const [logEndDate, setlogEndDate] = useState(todayValue);
  const [logDetails, setlogDetails] = useState("");
  const [logList, setLogList] = useState([]);
  const [logAdding, setlogAdding] = useState(false);

  //* hook for validation */
  const [validation, setValidation] = useState({
    hoursWarning: false,
    detailsWarning: false,
    statusWarning: false,
  });

  const editor = useRef(null);

  // const editorCustomConfig = joditEditorConfig(300);
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    minHeight: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setlogDetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  //* function to validate form */
  const validate = () => {
    let isValid = true;

    if (logHours === "") {
      setValidation((prevState) => ({ ...prevState, hoursWarning: true }));
      isValid = false;
    }

    if (taskStatusData === null) {
      setValidation((prevState) => ({ ...prevState, userWarning: true }));
      isValid = false;
    }

    if (logDetails === "") {
      setValidation((prevState) => ({ ...prevState, detailsWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //* select status */
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);
    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatusData(val.value);
    }
  };

  //* reset */
  const resetLogFormHandler = () => {
    setlogDetails("");
  };

  //get task details
  const getTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASK_DETAILS +
        `/${selectedTaskId}?token=${token}`;
      const response = await getData(requestUrl);

      // console.log("Response in task log tab ----->", response);

      if (response.status) {
        setlogHours(response.data.hours);
        // setlogStartDate(response.data.startdate);
        // setlogEndDate(response.data.enddate);
        settaskPercent(response.data.taskpercent);

        TaskStatusOptions.map((statusData) => {
          if (statusData.label == response.data.taskstatus) {
            statusSelectionHandler(statusData);
          }
        });

        if (response.data.projectdata) {
          settaskProjectId(response.data.projectdata?.value);
        }

        if (response.data.leadid) {
          settaskLeadId(response.data.leadid);
        }

        if (response.data.contact) {
          settaskContactId(response.data.contact);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //save log
  const saveLogHandler = async () => {
    if (validate()) {
      setlogAdding(true);

      const currentTime = getCurrentTime();
      const startTime = getStartTimeFromCurrentTime(logHours);

      try {
        let taskData = {
          leadid: taskLeadId,
          project: taskProjectId,
          contact: taskContactId,
          projecttask: params.id,
          completedpercent: taskStatusData,
          description: logDetails,
          startdate: logStartDate,
          enddate: logEndDate,
          starttime: startTime,
          endtime: currentTime,
          hours: logHours,
          taskpercent: taskPercent,
          price: 0,
          uploads: [],
          lastworkingdate: logEndDate,
          taskstarttime: "",
          taskendtime: "",
        };

        console.log("taskData", taskData);

        let response = {};

        let requestUrl =
          url.API_BASE_URL + url.API_ADD_PROJECT_TASK_LOG + `?token=${token}`;

        response = await postData(requestUrl, taskData);

        setlogAdding(false);

        console.log(response);
        if (response.status) {
          setMessageType("success");
          resetLogFormHandler();
          getTaskLogs();
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please fill up required fields");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //get task logs
  const getTaskLogs = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECT_TASK_LOGS +
        `?token=${token}&taskid=${params.id}`;

      // console.log("log list url----->", requestUrl);

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setLogList(response.data);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (params.id) {
      getTaskDetails();
      getTaskLogs();
    }
  }, [params.id]);

  return (
    <div className="d-flex flex-column h-100">
      {/* <!-- ========== Start log list Section ========== --> */}
      <div className="logs flex-fill overflow-auto p-4 task_logs">
        {logList.map((logData, index) => {
          return (
            <div key={index}>
              <div className="log-date pb-3">
                <p className="d-flex gap-2 align-items-center justify-content-center fs-md fw-semibold">
                  <span className="d-block">
                    {logData.logmonthstring} {logData.logyear}
                  </span>
                  <span className="d-flex align-items-center gap-1 text-gray ">
                    <span className="d-block material-symbols-outlined icon-lg">
                      schedule
                    </span>
                    <span>{logData.logmonthhour}Hr</span>
                  </span>
                </p>
              </div>
              {logData.logs.map((log, index2) => {
                return (
                  <div className="log mt-3" key={index2}>
                    <div className="d-flex gap-2">
                      <div
                        className="avatar rounded-circle overflow-hidden"
                        style={{ width: "24px", height: "24px" }}
                      >
                        <img
                          src={
                            log.userimage == ""
                              ? assetImages.defaultUser
                              : url.SERVER_URL + log.userimage
                          }
                          alt="Richard"
                          className="w-100 h-100 object-fit-cover object-center"
                        />
                      </div>
                      <div>
                        <p className="d-flex align-items-center gap-2 mb-2">
                          <span className="d-block fs-md fw-semibold">
                            {log.username}
                          </span>
                          <span className="d-block fs-sm text-gray">
                            {getDateFormatInSpanish(log.startdate)}
                          </span>
                          <span className="d-block fs-xs lh-1 text-primary gradient-light px-2 py-1 rounded-90">
                            {log.hours}hr
                          </span>
                        </p>
                        <p
                          className="message body-bg px-3 py-2 fs-sm rounded-10"
                          dangerouslySetInnerHTML={{
                            __html: log.description,
                          }}
                        ></p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      {/* <!-- ========== End log list Section ========== --> */}

      {/* <!-- ========== Start log save Section ========== --> */}
      <div className="log-form border border-gray-300 rounded-10 shadow-sm bg-light px-4 py-3">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="d-flex flex-column flex-lg-row gap-2">
              <div className="flex-fill">
                <label
                  htmlFor=""
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Time (Hours)")}
                </label>
                <input
                  type="number"
                  className={`form-control fs-sm shadow-none ${
                    validation.hoursWarning
                      ? "is-invalid"
                      : "border border-gray-300"
                  }`}
                  placeholder="Hours required"
                  value={logHours}
                  onChange={(e) => {
                    setlogHours(e.target.value);
                    setValidation((prevState) => ({
                      ...prevState,
                      hoursWarning: false,
                    }));
                  }}
                />
              </div>
              <div className="flex-fill">
                <label
                  htmlFor=""
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Dates")}
                </label>
                <div className="field-container d-flex flex-column flex-lg-row gap-lg-2 align-items-lg-center bg-lg-white border-lg border-gray-300 rounded-10">
                  <input
                    type="date"
                    id="startdate"
                    className="form-control fs-sm shadow-none border border-gray-300 mb-3 mb-lg-0"
                    placeholder={t("Start Date")}
                    value={logStartDate}
                    onChange={(e) => {
                      setlogStartDate(e.target.value);
                    }}
                  />
                  <input
                    type="date"
                    id="enddate"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("End Date")}
                    value={logEndDate}
                    onChange={(e) => {
                      setlogEndDate(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex-fill">
                <label
                  htmlFor=""
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Complete %")}
                </label>
                <input
                  type="number"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  value={taskPercent}
                  onChange={(e) => {
                    if (e.target.value >= 0 && e.target.value <= 100) {
                      settaskPercent(e.target.value);
                    }
                  }}
                />
              </div>
              <div className="task-status-wrapper">
                <label
                  htmlFor=""
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Task Status")}
                </label>
                <Select
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder="Select task status"
                  options={TaskStatusOptions}
                  value={taskStatusValue}
                  onChange={(val) => {
                    statusSelectionHandler(val);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label
              htmlFor=""
              className="d-block fs-sm fw-semibold mb-2 text-dark"
            >
              {t("Details")}
            </label>

            <JoditEditor
              ref={editor}
              value={logDetails}
              config={editorConfig}
              onBlur={(newContent) => {
                setlogDetails(newContent);
              }}
              onChange={(newContent, event) => {
                // setlogDetails(newContent);
              }}
            />

            {validation.detailsWarning && (
              <div className="invalid-feedback d-block mt-2">
                <p className="d-flex align-items-center gap-1 text-danger">
                  <span className="material-symbols-outlined icon-lg">
                    info
                  </span>
                  <span>{t("Please enter details")}</span> !
                </p>
              </div>
            )}
          </div>
          <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={saveLogHandler}
              disabled={logAdding ? true : false}
              style={{
                cursor: logAdding ? "not-allowed" : "pointer",
              }}
            >
              {logAdding ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {t("Saving...")}
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined me-1">save</span>{" "}
                  {t("Save")}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
      {/* <!-- ========== End log save Section ========== --> */}
    </div>
  );
};
export default CrmLogTab;
